// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as IndexRouteImport } from './routes/index'
import { Route as CasosRouteImport } from './routes/casos'
import { Route as CookiesRouteImport } from './routes/cookies'
import { Route as LlaveroNfcRouteImport } from './routes/llavero-nfc'
import { Route as LlaveroNfcQrRouteImport } from './routes/llavero-nfc-qr'
import { Route as PrivacidadRouteImport } from './routes/privacidad'
import { Route as ProductosRouteImport } from './routes/productos'
import { Route as ReembolsosRouteImport } from './routes/reembolsos'
import { Route as StandNfcRouteImport } from './routes/stand-nfc'
import { Route as StandNfcQrRouteImport } from './routes/stand-nfc-qr'
import { Route as StandPersonalizadoNfcRouteImport } from './routes/stand-personalizado-nfc'
import { Route as StandPersonalizadoNfcQrRouteImport } from './routes/stand-personalizado-nfc-qr'
import { Route as TarjetaNfcRouteImport } from './routes/tarjeta-nfc'
import { Route as TarjetaNfcQrRouteImport } from './routes/tarjeta-nfc-qr'
import { Route as TerminosRouteImport } from './routes/terminos'
import { Route as TransferenciaRouteImport } from './routes/transferencia'
import { Route as TransferenciaFullMarketRouteImport } from './routes/transferencia-full-market'
import { Route as CasosSlugRouteImport } from './routes/casos_.$slug'
import { Route as ProductosSlugRouteImport } from './routes/productos_.$slug'
import { Route as VideosStandNfcResenasGoogleRouteImport } from './routes/videos.stand-nfc-resenas-google'

const IndexRoute = IndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => rootRouteImport
          })
const CasosRoute = CasosRouteImport.update({
            id: '/casos',path: '/casos',getParentRoute: () => rootRouteImport
          })
const CookiesRoute = CookiesRouteImport.update({
            id: '/cookies',path: '/cookies',getParentRoute: () => rootRouteImport
          })
const LlaveroNfcRoute = LlaveroNfcRouteImport.update({
            id: '/llavero-nfc',path: '/llavero-nfc',getParentRoute: () => rootRouteImport
          })
const LlaveroNfcQrRoute = LlaveroNfcQrRouteImport.update({
            id: '/llavero-nfc-qr',path: '/llavero-nfc-qr',getParentRoute: () => rootRouteImport
          })
const PrivacidadRoute = PrivacidadRouteImport.update({
            id: '/privacidad',path: '/privacidad',getParentRoute: () => rootRouteImport
          })
const ProductosRoute = ProductosRouteImport.update({
            id: '/productos',path: '/productos',getParentRoute: () => rootRouteImport
          })
const ReembolsosRoute = ReembolsosRouteImport.update({
            id: '/reembolsos',path: '/reembolsos',getParentRoute: () => rootRouteImport
          })
const StandNfcRoute = StandNfcRouteImport.update({
            id: '/stand-nfc',path: '/stand-nfc',getParentRoute: () => rootRouteImport
          })
const StandNfcQrRoute = StandNfcQrRouteImport.update({
            id: '/stand-nfc-qr',path: '/stand-nfc-qr',getParentRoute: () => rootRouteImport
          })
const StandPersonalizadoNfcRoute = StandPersonalizadoNfcRouteImport.update({
            id: '/stand-personalizado-nfc',path: '/stand-personalizado-nfc',getParentRoute: () => rootRouteImport
          })
const StandPersonalizadoNfcQrRoute = StandPersonalizadoNfcQrRouteImport.update({
            id: '/stand-personalizado-nfc-qr',path: '/stand-personalizado-nfc-qr',getParentRoute: () => rootRouteImport
          })
const TarjetaNfcRoute = TarjetaNfcRouteImport.update({
            id: '/tarjeta-nfc',path: '/tarjeta-nfc',getParentRoute: () => rootRouteImport
          })
const TarjetaNfcQrRoute = TarjetaNfcQrRouteImport.update({
            id: '/tarjeta-nfc-qr',path: '/tarjeta-nfc-qr',getParentRoute: () => rootRouteImport
          })
const TerminosRoute = TerminosRouteImport.update({
            id: '/terminos',path: '/terminos',getParentRoute: () => rootRouteImport
          })
const TransferenciaRoute = TransferenciaRouteImport.update({
            id: '/transferencia',path: '/transferencia',getParentRoute: () => rootRouteImport
          })
const TransferenciaFullMarketRoute = TransferenciaFullMarketRouteImport.update({
            id: '/transferencia-full-market',path: '/transferencia-full-market',getParentRoute: () => rootRouteImport
          })
const CasosSlugRoute = CasosSlugRouteImport.update({
            id: '/casos_/$slug',path: '/casos/$slug',getParentRoute: () => rootRouteImport
          })
const ProductosSlugRoute = ProductosSlugRouteImport.update({
            id: '/productos_/$slug',path: '/productos/$slug',getParentRoute: () => rootRouteImport
          })
const VideosStandNfcResenasGoogleRoute = VideosStandNfcResenasGoogleRouteImport.update({
            id: '/videos/stand-nfc-resenas-google',path: '/videos/stand-nfc-resenas-google',getParentRoute: () => rootRouteImport
          })

const rootRouteChildren = {
  IndexRoute: IndexRoute,CasosRoute: CasosRoute,CookiesRoute: CookiesRoute,LlaveroNfcRoute: LlaveroNfcRoute,LlaveroNfcQrRoute: LlaveroNfcQrRoute,PrivacidadRoute: PrivacidadRoute,ProductosRoute: ProductosRoute,ReembolsosRoute: ReembolsosRoute,StandNfcRoute: StandNfcRoute,StandNfcQrRoute: StandNfcQrRoute,StandPersonalizadoNfcRoute: StandPersonalizadoNfcRoute,StandPersonalizadoNfcQrRoute: StandPersonalizadoNfcQrRoute,TarjetaNfcRoute: TarjetaNfcRoute,TarjetaNfcQrRoute: TarjetaNfcQrRoute,TerminosRoute: TerminosRoute,TransferenciaRoute: TransferenciaRoute,TransferenciaFullMarketRoute: TransferenciaFullMarketRoute,CasosSlugRoute: CasosSlugRoute,ProductosSlugRoute: ProductosSlugRoute,VideosStandNfcResenasGoogleRoute: VideosStandNfcResenasGoogleRoute
}
export const routeTree = rootRouteImport._addFileChildren(rootRouteChildren)